import { render } from "./AudienceGeography.vue?vue&type=template&id=09100472&scoped=true"
import script from "./AudienceGeography.vue?vue&type=script&lang=js"
export * from "./AudienceGeography.vue?vue&type=script&lang=js"

import "./AudienceGeography.vue?vue&type=style&index=0&id=09100472&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09100472"]])

export default __exports__